import { beneficiaryQueryOptions } from '@/pages/private/Beneficiaries/hooks/beneficiary.hook';
import { queryClient } from '@/providers/QueryClientProvider';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_dashboard/beneficiaries/$id/_tabs'
)({
  loader: async ({ params }) => {
    const { id } = params;

    const queryOptions = beneficiaryQueryOptions(id);

    const beneficiary = await queryClient.fetchQuery(queryOptions);
    return beneficiary;
  },
});
